import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const title = 'Nav Link';
export const _frontmatter = {};
const layoutProps = {
  title,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "nav-link"
    }}>{`Nav Link`}</h1>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Link
  sx={{
    display: 'inline-block',
    fontWeight: 'bold',
    px: 2,
    py: 1,
    color: 'inherit',
  }}>
  Nav Link
</Link>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      